import { defineMessages } from 'react-intl'

const globalMessages = defineMessages({
  guests: {
    id: 'global.guests',
  },
  guest: {
    id: 'global.guest-single',
  },
  nights: {
    id: 'global.nights',
  },
  night: {
    id: 'global.night',
  },
  book: {
    id: 'global.book',
  },
  select: {
    id: 'global.select',
  },
  total: {
    id: 'global.total',
  },
  showMore: {
    id: 'global.show-more',
  },
  showLess: {
    id: 'global.show-less',
  },
  map: {
    id: 'global.map',
  },
  remove: {
    id: 'global.remove',
  },
  roomsFrom: {
    id: 'global.from-amount-night',
  },
  checkAvailability: {
    id: 'global.availability-check',
  },
  filter: {
    id: 'global.filters',
  },
  sort: {
    id: 'global.order-by',
  },
  mapView: {
    id: 'global.map-view',
  },
  facilities: {
    id: 'global.facilities',
  },
  accommodationType: {
    id: 'global.accommodation',
  },
  guestRating: {
    id: 'global.guest-rating',
  },
  london: {
    id: 'global.london',
  },
  dubai: {
    id: 'global.dubai',
  },
  orlando: {
    id: 'global.orlando',
  },
  instanbul: {
    id: 'global.istanbul',
  },
  paris: {
    id: 'global.paris',
  },
  amsterdam: {
    id: 'global.amsterdam',
  },
  marrakech: {
    id: 'global.marrakech',
  },
  varadero: {
    id: 'global.varadero',
  },
  today: {
    id: 'global.today',
  },
  activateAccount: {
    id: 'global.active-account',
  },
  password: {
    id: 'global.password',
  },
  repeatPassword: {
    id: 'subscription.repeat-password',
  },
  newPassword: {
    id: 'global.new-password',
  },
  repeatNewPassword: {
    id: 'global.repeat-new-password',
  },
  createAccount: {
    id: 'global.create-account',
  },
  signUp: {
    id: 'global.sign-up',
  },
  email: {
    id: 'global.email',
  },
  login: {
    id: 'global.login',
  },
  done: {
    id: 'global.done',
  },
  save: {
    id: 'global.save',
  },
  prime: {
    id: 'global.prime',
  },
  currentPassword: {
    id: 'global.current-password',
  },
})

export default globalMessages
